import { render } from "./DefaultFooter.vue?vue&type=template&id=33597eba&scoped=true"
import script from "./DefaultFooter.vue?vue&type=script&lang=js"
export * from "./DefaultFooter.vue?vue&type=script&lang=js"

import "./DefaultFooter.vue?vue&type=style&index=0&id=33597eba&lang=scss&scoped=true"

import exportComponent from "/home/hudson/workspace/103261_ib-gwms-customer-xc-devops/ib-gwms-customer-xc-devops/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33597eba"]])

export default __exports__